module.exports = __webpack_public_path__ + "static/media/2.8a86acf6.png";